import { createContext, use } from 'react';

import type { PerformanceDashboardFilters } from '@/features/performance-dashboard/lib/performanceDashboardFilters.types';
import type { Axis } from '@/features/performance-dashboard/schemas/dashboardResults';

type DashboardGridContextValue = {
  isTaskScoped: boolean;
  isStudentScoped: boolean;
  idTask: number | undefined;
  filters: PerformanceDashboardFilters;
  axes: Axis[];
  isLoading: boolean;
};

export const DashboardGridContext = createContext<DashboardGridContextValue | null>(null);

export function useDashboardGridContext(): DashboardGridContextValue {
  const context = use(DashboardGridContext);
  if (!context) throw new Error('useDashboardGridContext must be used within DashboardGrid');
  return context;
}
